import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {Avatar} from "antd";
import UserPlaceholder from "../../../assets/images/user_placeholder.svg";
import GridContainer from "../../global/GridContainer/GridContainer";
import ImageApi from "../../../api/image";
import {languages} from "../../../constants/language";

const BACK_TEXT = { '/': 'Back to Ask Aunty or Uncle List' };

const AuntyOrUncleProfile = ({ aunties, getAunties }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [aunty, setAunty] = useState('');
    const [language, setLanguage] = useState('');
    const [imageUrl, setImageUrl] = useState('');

    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');

    useEffect(() => {
        getAunties({});
        if (id) {
            const data = aunties.filter((item) => item.id === id)

            if (data.length > 0) {
                const foundAunty = data[0];
                setAunty(foundAunty);
                if (foundAunty.language_id) {
                    const foundLanguage = languages.filter((item) => item.id === foundAunty.language_id);
                    if (foundLanguage.length > 0) {
                        setLanguage(foundLanguage[0].name);
                    }
                }
            }
        }
    }, []);

    // Get user avatar
    useEffect(() => {
        if (!aunty.image || !aunty.image.url) return;

        ImageApi.getImage(aunty.image.url).then((avatar) => setImageUrl(avatar));
    }, [aunty]);

    return (
        <div className="collegue-profile-container">
            <GridContainer>
                <div>
                    <div className="btn-container collegue-profile-container--nav">
                        <button onClick={() => navigate(-1)} className="back-btn p-0">
                            <FontAwesomeIcon className="me-2" icon={['fas', 'chevron-left']} />
                            {BACK_TEXT['/ask-aunty-or-uncle' || '/'] || 'Go back'}
                        </button>
                    </div>
                    <div className="collegue-profile-container--upper">
                        {aunty ? (
                            <div>
                                <Avatar
                                    className="collegue-avatar"
                                    size={147}
                                    shape="square"
                                    src={imageUrl || UserPlaceholder}
                                />
                                <h2 className="title">{`${aunty.first_name} ${aunty.last_name}`}</h2>
                                <p className="subtitle">{aunty.job_title}</p>

                                {aunty.company_name && (
                                    <p className="labelledContent">
                                        Trust:
                                        <span className="labelledContent--inner">{aunty.company_name}</span>
                                    </p>
                                )}

                                {aunty.nationality && (
                                    <p className="labelledContent">
                                        Nationality:
                                        <span className="labelledContent--inner">{aunty.nationality}</span>
                                    </p>
                                )}

                                {language && (
                                    <p className="labelledContent">
                                        Preferred language:
                                        <span className="labelledContent--inner">{language}</span>
                                    </p>
                                )}

                                {aunty.religion && (
                                    <p className="labelledContent">
                                        Religion:
                                        <span className="labelledContent--inner">{aunty.religion}</span>
                                    </p>
                                )}

                                {aunty.description && (
                                    <p className="labelledContent">
                                        {aunty.description}
                                    </p>
                                )}
                                
                                {aunty.contact_link && (
                                    <p className={aunty.phone_number ? 'email pb-3' : 'email'}>
                                        Booking Link:
                                        <a href={aunty.contact_link} className="email--inner" target={'_blank'} rel="noreferrer">
                                            {`${aunty.contact_link.length >= 40 ? `${aunty.contact_link.substring(0, 40)}...` : aunty.contact_link }`}
                                        </a>
                                    </p>
                                )}

                                {aunty.phone_number && aunty.phone_number.length > 0 && (
                                    <p className="phone">
                                        Phone No:
                                        <span className="email--inner">{aunty.phone_number}</span>
                                    </p>
                                )}
                            </div>
                        ) : (
                            <p>Profile not found!</p>
                        )}
                    </div>
                </div>
            </GridContainer>
        </div>
    );
};

export default AuntyOrUncleProfile;
